import { z } from "zod";

const schema = z.object({
  id: z.string().optional(),
  name: z
    .string({ required_error: "Interview name is required" })
    .min(1, "Interview name is required"),
  duration: z.coerce
    .number({ required_error: "Duration is required" })
    .min(0, "Duration must be greater than 0"),
  participants: z
    .string({ required_error: "Interviewer(s) is required" })
    .array()
    .min(1, "At least one interviewer is required"),
});

type Schema = z.infer<typeof schema>;

export {
  schema as companyOpportunityInterviewSchema,
  type Schema as CompanyOpportunityInterviewSchema,
};
